import React from 'react';
import PropTypes from 'prop-types';
import 'components/sales/activityTimeline/ActivityTimeline.css';
import './DivLayoutV2.css';

const DivLayoutV2Timeline = ({ children, className = '' }) => (
  <div className={`div-layout-v2-timeline pr-timeline-simple ${className}`.trim()}>
    {children}
  </div>
);

DivLayoutV2Timeline.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default DivLayoutV2Timeline;
